import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { LOCAL__workspace_set_is_all_data_loaded } from '@/state/workspace/entity/LOCAL__workspace_set_is_all_data_loaded';
import { PAGE__error } from './PAGE__error';

export function PAGE__404() {
  const dispatch = use_dispatch();

  /*
   * EFFECTS
   */

  use_effect(() => void dispatch(LOCAL__workspace_set_is_all_data_loaded(true)), []);

  /*
   * HTML
   */
  return <PAGE__error title="404" />;
}
